import React from "react";
import styled from "styled-components";
import { HeaderD, Tab } from "./HistoryStyled";
import { ReactComponent as CloseSvg } from "../../../assets/close.svg";
// import { ReactComponent as UsdSVG } from "./usd.svg";
import currencies from "../../../lib/currencies/currencies";

import { requestBetReplay } from "../../../lib/socketMessages";

import useSound from "use-sound";
import closeSound from "../../../audio/goBack.mp3";
import tabClick from "../../../audio/tabClick.mp3";
import goForward from "../../../audio/goForward.mp3";

export function Header({
  handleAbove,
  handleActive,
  active,
  userSettings: { sound, volume },
}) {
  const [closeSfx] = useSound(closeSound, { volume });
  const [tabSFX] = useSound(tabClick, { volume });

  return (
    <HeaderD>
      <Tab
        onClick={() => {
          if (sound && active !== "my") tabSFX();
          handleActive("my");
        }}
        active={active === "my"}
      >
        <div className="inner"></div>
        <p>MY</p>
      </Tab>
      <Tab
        onClick={() => {
          if (sound && active !== "all") tabSFX();
          handleActive("all");
        }}
        active={active === "all"}
      >
        <div className="inner"></div>
        <p>ALL</p>
      </Tab>
      <Tab
        onClick={() => {
          if (sound && active !== "high") tabSFX();
          handleActive("high");
        }}
        active={active === "high"}
      >
        <div className="inner"></div>
        <p>HIGH</p>
      </Tab>
      <CloseSvg
        style={{ width: "36px", cursor: "pointer" }}
        onClick={() => {
          if (sound) closeSfx();
          handleAbove(false);
        }}
      />
    </HeaderD>
  );
}

export const Tr = ({
  username,
  payout,
  profit,
  t,
  handleAbove,
  handleVerifyBet,
  user_id,
  handleNotification,
  userSettings: { sound, volume },
}) => {
  const [goForwardSfx] = useSound(goForward, { volume });

  const clickHandler = (id, bet_user_id) => {
    if (sound) goForwardSfx();

    if (bet_user_id === user_id) {
      handleAbove("betReply");
      requestBetReplay(id);
    } else {
      handleNotification("You can see only your bet reply");
    }
  };
  return (
    <Trstyled
      onClick={() => clickHandler(t.round_id, t.user_id)}
      cursorPointer={user_id === t.user_id}
    >
      <td className="username">{username}</td>
      <td className="payout">{payout}x</td>
      <td
        className="currency"
        style={
          profit > 0
            ? {
              textShadow: "0 0 8px  #9791ff",
              filter: "brightness(150%)",
            }
            : undefined
        }
      >
        <p className="winAmount">{profit}</p>
        <p style={{ marginLeft: '2px' }}>
          {currencies[t.currency]}
          {t.winAmount - t.betAmount > 0 ? "↑" : "↓"}
        </p>
      </td>
    </Trstyled>
  );
};

const Trstyled = styled.tr`
  font-size: 12px;
  ${(p) => (p.cursorPointer ? "cursor: pointer;" : "cursor: auto;")}
  td {
    padding-bottom: 10px;
  }

  .username {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 88px;
  }
  .payout {
    width: 35px;
  }
  .profit {
    text-align: right;
    padding-right: 4px;
    width: 70px;
  }
  .currency{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
